/**
 * @generated SignedSource<<bc99a62c4eb8102fc854786a36828b06>>
 * @relayHash 727771f625528321882e822398d219fd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e7c474d1f3ca6df3ee1f24f128085a09a26f1796477554de890782e7d51f18e9

import type { ConcreteRequest } from 'relay-runtime';
export type ResourceAccessType = "EDIT" | "VIEW" | "%future added value";
export type UsersContentAccessQuery$variables = {
  accessType: ResourceAccessType;
  accountIds: ReadonlyArray<string | null>;
  cloudId: string;
  contentId: string;
};
export type UsersContentAccessQuery$data = {
  readonly confluence_userContentAccess: {
    readonly canAccessList: ReadonlyArray<string | null>;
    readonly cannotAccessList: ReadonlyArray<string | null>;
  } | null;
};
export type UsersContentAccessQuery = {
  response: UsersContentAccessQuery$data;
  variables: UsersContentAccessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accessType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accessType",
        "variableName": "accessType"
      },
      {
        "kind": "Variable",
        "name": "accountIds",
        "variableName": "accountIds"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ConfluenceUserContentAccessResult",
    "kind": "LinkedField",
    "name": "confluence_userContentAccess",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "canAccessList"
      },
      {
        "kind": "ScalarField",
        "name": "cannotAccessList"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "UsersContentAccessQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UsersContentAccessQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "727771f625528321882e822398d219fd",
    "id": "e7c474d1f3ca6df3ee1f24f128085a09a26f1796477554de890782e7d51f18e9",
    "metadata": {},
    "name": "UsersContentAccessQuery",
    "operationKind": "query",
    "text": "query UsersContentAccessQuery($accessType:ResourceAccessType!,$accountIds:[String]!,$cloudId:ID!,$contentId:ID!){confluence_userContentAccess(accessType:$accessType,accountIds:$accountIds,cloudId:$cloudId,contentId:$contentId){canAccessList,cannotAccessList}}"
  }
};
})();

(node as any).hash = "3af84917efe0ce91f68b18f96d2f126c";

export default node;
